import axios from "axios";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";

const instance = axios.create({
  baseURL: "https://nameless-waters-61909.herokuapp.com",
  //baseURL: "http://localhost:3000",
});

instance.interceptors.request.use(
  //Called before making request
  async (config) => {
    const token = await AsyncStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  //Called if there is an error
  (err) => {
    return Promise.reject(err);
  }
);

export default instance;
